import React from 'react'
import PropTypes from 'prop-types'

import {formatDateString} from '../../../utils'

import ProductStarRating from './ProductStarRating'

const UserReviewDetails = ({date, score, user, event}) => {
  const reviewDate = formatDateString(date, 'MMM DD, YYYY')
  return (
    <div className="product-review-user-details">
      <ProductStarRating score={score} />
      <h2 className="review-user">{user.displayName}</h2>
      <h3 className="review-date">{reviewDate}</h3>
      <p className="review-event-type">{event}</p>
    </div>
  )
}

UserReviewDetails.propTypes = {
  date: PropTypes.string.isRequired,
  score: PropTypes.number.isRequired,
  user: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
  }).isRequired,
  event: PropTypes.string,
}

export default UserReviewDetails
